var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoArrowright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96789 15.4343C7.76778 15.2446 7.663 15.003 7.65354 14.7098C7.64408 14.4165 7.73977 14.175 7.9406 13.9852L13.2889 8.91316L1.0915 8.91316C0.782239 8.91316 0.522828 8.81379 0.313262 8.61505C0.103696 8.41631 -0.000723999 8.17064 3.66601e-06 7.87805C3.67016e-06 7.58477 0.104787 7.33876 0.314353 7.14002C0.52392 6.94128 0.782967 6.84225 1.0915 6.84294L13.2889 6.84294L7.9406 1.77091C7.7405 1.58114 7.64481 1.33962 7.65354 1.04634C7.66227 0.753059 7.76706 0.511533 7.96789 0.321764C8.168 0.131994 8.42268 0.0371094 8.73193 0.0371094C9.04119 0.0371094 9.29587 0.131994 9.49598 0.321764L16.6998 7.15348C16.809 7.23973 16.8865 7.34773 16.9323 7.47746C16.9782 7.6072 17.0007 7.74073 17 7.87805C17 8.01607 16.9774 8.14545 16.9323 8.26622C16.8872 8.38698 16.8097 8.49911 16.6998 8.60263L9.49598 15.4343C9.29587 15.6241 9.04119 15.719 8.73193 15.719C8.42268 15.719 8.168 15.6241 7.96789 15.4343Z",
    fill: "#535353"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowright);
export default __webpack_public_path__ + "static/media/ico-arrowright.95ce6127f82de655208226619513d59c.svg";
export { ForwardRef as ReactComponent };